<template>
  <div>
    <v-row v-if="systemInfo">
      <v-col cols="6">
        <h2>Zużycie RAM {{ ramUsage.toFixed(2) }} / {{ systemInfo.totalMemory.toFixed(2) }} MB</h2>
        <donut-chart v-if='ramUsageChartData' :chartData="ramUsageChartData"></donut-chart>
      </v-col>
      <v-col cols="6">
        <h2>Zużycie CPU {{ cpuUsage.toFixed(2) }} / 100 %</h2>
        <donut-chart v-if="cpuUsageChartData" :chartData="cpuUsageChartData"></donut-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col >
        <v-checkbox v-model="updateSystemInfo" label="Aktualizacja w czasie rzeczywistym"></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Raporty</h2>
        <v-data-table :headers="headers" :items="items" disable-filtering disable-pagination disable-sort
                      hide-default-footer @click:row="rowClick">
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {donutChart} from "@/components/charts";
import {colorsForChart} from "@/helpers";
import {notify} from "@/helpers";

const signalR = require('@microsoft/signalr');
export default {
  components: {
    donutChart
  },
  computed: {
    ramUsage() {
      let usage = 0.0
      if (!this.systemInfo) {
        return usage
      }
      this.systemInfo.processInfos.forEach(el => usage += parseFloat(el.ramUsage))
      return usage
    },
    cpuUsage() {
      let usage = 0.0
      if (!this.systemInfo) {
        return usage;
      }
      this.systemInfo.processInfos.forEach(el => usage += parseFloat(el.cpuUsage))
      return usage
    }
  },
  data() {
    return {
      updateSystemInfo: true,
      ramUsageChartData: null,
      cpuUsageChartData: null,
      items: [
        {
          reportName: 'Dzisiejsze rezerwacje',
          path: '/Reports/TodayReservation',
          description: "Raport zawiera informacje na temat zajetych oraz wolnych slotów z dnia dzisiejszego pogrupowane według wdrożeń"
        },
        {
          reportName: 'Potwierdzone rezerwacje w ostatnim tygodniu',
          path: '/Reports/LastWeekConfirmReservation',
          description: "Raport zawiera informacje o potwierdzonych rezerwacjach z zeszłego tygodnia pogrupowane według daty potwierdzenia oraz wdrożenia"
        }
      ],
      headers: [
        {
          text: "Nazwa raportu",
          value: "reportName"
        },
        {
          text: "Opis raportu",
          value: 'description'
        }
      ],
      connection: null,
      systemInfo: null,
    }
  },
  watch: {
    'connection.connectionState': function (newVal) {
      if (newVal.toLowerCase() === 'connected') {
        this.connection.invoke("SubscribeSystemInfo");
      }
    },
    updateSystemInfo: function (newVal) {
      if (this.connection) {
        if (newVal) {
          this.connection.start();
        } else {
          this.connection.stop();
        }
      }
    }
  },
  methods: {
    rowClick(item) {
      this.$router.push({path: item.path})
    },
    signalRConnect() {
      let vm = this;
      vm.connection = new signalR.HubConnectionBuilder()
          .withUrl(document.baseAPIurl + "hubs/portalHub", {
            accessTokenFactory: () => localStorage.getItem("token")
          })
          .withAutomaticReconnect()
          .build();

      vm.connection.on("SystemInfo", data => {
        vm.systemInfo.processInfos = data;
        vm.convertDataToRamChart();
        vm.convertDataToCpuChart();
      })
      vm.connection.onreconnected = () => {
        console.log('reconnect')
      }
      vm.connection.start();
    },
    convertDataToRamChart() {
      let vm = this;
      if (!vm.systemInfo) {
        return null
      }
      let processCountToDisplay = 10;
      let sortData = vm.systemInfo.processInfos.sort((a, b) => a.ramUsage > b.ramUsage ? -1 : a.ramUsage < b.ramUsage ? 1 : 0);
      let data = {
        datasets: [{
          data: sortData.slice(0, processCountToDisplay).map(el => parseFloat(el.ramUsage).toFixed(2)),
          backgroundColor: colorsForChart
        }],
        labels: sortData.slice(0, processCountToDisplay).map(el => el.processName)
      }
      let otherUsage = 0.0
      sortData.slice(processCountToDisplay + 1).forEach(el => {
        otherUsage += parseFloat(el.ramUsage);
      });
      data.labels.push("inne");
      data.labels.push("wolne");
      data.datasets[0].data.push(parseFloat(otherUsage).toFixed(2));
      let freeRam = parseFloat(vm.systemInfo.totalMemory - vm.ramUsage).toFixed(2)
      if (freeRam <= 0) {
        freeRam = 0;
      }
      data.datasets[0].data.push(freeRam);
      vm.ramUsageChartData = data;
    },
    convertDataToCpuChart() {
      let vm = this;
      if (!vm.systemInfo) {
        return null
      }
      let processCountToDisplay = 10;
      let sortData = vm.systemInfo.processInfos.sort((a, b) => a.cpuUsage > b.cpuUsage ? -1 : a.cpuUsage < b.cpuUsage ? 1 : 0);
      let data = {
        datasets: [{
          data: sortData.slice(0, processCountToDisplay).map(el => parseFloat(el.cpuUsage).toFixed(2)),
          backgroundColor: colorsForChart
        }],
        labels: sortData.slice(0, processCountToDisplay).map(el => el.processName)
      }
      let otherUsage = 0.0
      sortData.slice(processCountToDisplay + 1).forEach(el => {
        otherUsage += parseFloat(el.cpuUsage);
      });
      data.labels.push("inne");
      data.labels.push("wolne");
      data.datasets[0].data.push(parseFloat(otherUsage).toFixed(2));
      data.datasets[0].data.push(parseFloat(100.0 - vm.cpuUsage).toFixed(2));
      vm.cpuUsageChartData = data;
    }
  },
  mounted() {
    let vm = this;
    vm.$http.get("Report/GeneralReportData").then(response => {
      vm.systemInfo = response.data;
      vm.convertDataToRamChart();
      vm.convertDataToCpuChart();
    })
    this.signalRConnect();
  },
  beforeDestroy() {
    this.connection?.stop();
  }
}
</script>

<style>
.v-data-table tbody tr:hover {
  cursor: pointer;
}
</style>
